import { render, staticRenderFns } from "./CenterLayout.vue?vue&type=template&id=0e731a50&scoped=true&"
import script from "./CenterLayout.vue?vue&type=script&lang=js&"
export * from "./CenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./CenterLayout.vue?vue&type=style&index=0&id=0e731a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e731a50",
  null
  
)

export default component.exports